import { type AvailableAccessKeyInstance } from '@/types/trpc/accessKeys';
import { type CellProps } from '@/shared/hooks/table/types';
import TruncatedCell from '@/shared/components/2.0/customTableCells/TruncatedCell';

const AccessKeyAvailableBuildingsTableCell: React.FC<
  CellProps<AvailableAccessKeyInstance>
> = ({ rowData }) => {
  const text =
    rowData.buildings?.map((b) => b.buildingName).join(', ') || '-';

  return <TruncatedCell value={text} />;
};

export default AccessKeyAvailableBuildingsTableCell;
